import React from 'react';

const ACTOR_LABELS = {
  tempWorker: "par l'intérimaire",
  company: "par l'entreprise",
  admin: 'par Jobbiz',
};

const MissionInterruptionNotice = ({ interruption }) => {
  if (!interruption) return null;

  const { at, actor, reason, comment } = interruption;
  const parsedDate = at ? new Date(at) : null;
  const headline = [
    'Interrompue',
    ACTOR_LABELS[actor],
    parsedDate && !isNaN(parsedDate.getTime())
      ? `le ${parsedDate.toLocaleDateString('fr-FR')}`
      : null,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={'mt-2 bg-gray-50 border border-gray-200 rounded-md p-3 w-full'}>
      <div className={'text-sm font-medium text-gray-900'}>{headline}</div>
      {reason && (
        <div className={'text-sm text-gray-700 mt-1'}>Motif : {reason}</div>
      )}
      {comment && (
        <div className={'text-sm text-gray-700 mt-1'}>« {comment} »</div>
      )}
    </div>
  );
};

export default MissionInterruptionNotice;
